import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { environment } from '../environments/environment';
import { map, Observable } from 'rxjs';
import { SelectedFile } from '../models/client-models/selected-file';
import { UploadedFile } from '../models/server-models/entities/uploaded-file';

@Injectable({ providedIn: 'root' })
export class BlobFilesService {
  httpClient = inject(HttpClient);

  uploadFiles(
    files: SelectedFile[]
  ): Observable<{ progress?: number; uploadedFiles?: UploadedFile[]; errors: string[] }> {
    const formData = new FormData();

    files.forEach((item, index) => {
      formData.append(`file${index}`, item.file);
    });

    return this.httpClient
      .post(`${environment.uploadFuncUrl}/api/uploadfilefunc`, formData, {
        reportProgress: true,
        observe: 'events',
      })
      .pipe(map((event) => this.handleUploadProgress(event)));
  }

  downloadInZip(userId: string, uniqueFileNames: string[]): Observable<{ downloadedBytes?: number; blob?: Blob }> {
    return this.httpClient
      .post(
        environment.uploadFuncUrl + '/api/DownloadFilesInZipFunc',
        {
          UserId: userId,
          UniqueFileNames: uniqueFileNames,
        },
        {
          reportProgress: true,
          observe: 'events',
          responseType: 'blob',
        }
      )
      .pipe(map((event) => this.handleDownloadProgress(event)));
  }

  private handleDownloadProgress(event: HttpEvent<any>): { downloadedBytes?: number; blob?: Blob } {
    switch (event.type) {
      case HttpEventType.DownloadProgress:
        return {
          downloadedBytes: event.loaded,
        };
      case HttpEventType.Response:
        return {
          blob: event.body,
        };
      default:
        return {};
    }
  }

  private handleUploadProgress(event: HttpEvent<any>): any {
    switch (event.type) {
      case HttpEventType.UploadProgress:
        return {
          progress: Math.round((100 * event.loaded) / (event.total ?? 1)),
        };
      case HttpEventType.Response:
        return event.body;
      default:
        return event;
    }
  }
}
